import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilsModule } from './utils/utils.module';
import { UserModule } from './user/user.module';
import { UiKitModule } from './ui-kit/ui-kit.module';
import { ConfigurationsModule } from './configurations/configurations.module';
import { AuthenticationModule } from './authentication/authentication.module';
import { TranslationsModule } from './translations/translations.module';
import { MappingsModule } from './mappings/mappings.module';
import { BoardStructureModule } from './board-structure/board-structure.module';
import { NotificationsModule } from './notifications/notifications.module';
import { CommonFeaturesModule } from './common-features/common-features.module';

const sharedModules = [
  CommonModule,
  UtilsModule,
  UserModule,
  UiKitModule,
  ConfigurationsModule,
  AuthenticationModule,
  TranslationsModule,
  MappingsModule,
  BoardStructureModule,
  NotificationsModule,
  CommonFeaturesModule
]


@NgModule({
  declarations: [],
  imports: sharedModules,
  exports: sharedModules
})
export class SharedModule { }
